/**
  * 深色背景 光伏主页--蓝色折线图
  * @param unit 单位
  * @param xData []x轴数据
  * @param dataArr [{name:'',data:[]}]数据合集
*/
import { dealBigNum } from "@/assets/js/utils";
export function setOption(paramObj) {
  let colorList = [
    {
      color: "#3090F6",
      color3: "rgba(48,144,246,.3)",
      color0: "rgba(48,144,246,0)",
    },
    {
      color: "#F1EF30",
      color3: "rgba(241,239,48,.3)",
      color0: "rgba(241,239,48,0)",
    },
    {
      color: "#28CCCB",
      color3: "rgba(40,204,203,.3)",
      color0: "rgba(40,204,203,0)",
    },
  ];
  let option = {
    tooltip: {
      trigger: "axis",
      formatter: function (params) {
        let result = params[0].name + "<br>";
        params.forEach(function (item) {
          result +=
            item.marker +
            " " +
            item.seriesName +
            " : " +
            dealBigNum(item.value) +
            paramObj.unit +
            "</br>";
        });
        return result;
      },
    },
    legend: {
      show: true,
      textStyle: {
        color: "#fff",
      },
      right: "2%",
      top: "2%",
    },
    grid: {
      top: "50px",
      left: "60px",
      right: "15px",
      bottom: "40px",
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        axisLine: {
          show: false,
        },
        axisLabel: {
          // interval: 0,
          color: "#CBCBCB",
          margin: 15,
        },
        axisTick: {
          show: false,
        },
        data: paramObj.xData,
      },
    ],
    yAxis: [
      {
        type: "value",
        name: "单位:" + paramObj.unit,
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisLabel: {
          margin: 10,
          fontSize: 10,
          color: "#fff",
        },
        splitLine: {
          lineStyle: {
            color: "#082D50",
          },
        },
      },
    ],
    dataZoom: [
      {
        type: "inside",
      }
    ],
    series: [],
  };
  paramObj.dataArr.forEach((item, index) => {
    option.series.push({
      type: "line",
      name: item.name,
      smooth: true,
      symbol: "circle",
      symbolSize: 2,
      lineStyle: {
        width: 2,
      },
      areaStyle: {
        color: {
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: colorList[index].color3,
            },
            {
              offset: 1,
              color: colorList[index].color0,
            },
          ],
          shadowColor: "rgba(0, 0, 0, 0.1)",
          shadowBlur: 10,
        },
      },
      itemStyle: {
        color: colorList[index].color,
      },
      data: item.data,
    });
  });

  return option
  
}